import { tokenStorage } from '@/features/auth/utils/tokenStorage';

export type AuthHeadersOptions = {
  withFirebaseSession?: boolean;
  withTempToken?: boolean;
  withTempExpired?: boolean;
  withMfaToken?: boolean;
  withLocation?: boolean;
};


export function buildAuthHeaders(
  options: AuthHeadersOptions = {}
): Record<string, string> {
  const headers: Record<string, string> = {};

  if (options.withFirebaseSession) {
    headers['x-firebase-session'] = tokenStorage.getFirebaseToken();
  }
  if (options.withTempToken) {
    headers['x-temp-token'] = tokenStorage.getTempToken().tempToken;
  }
  if (options.withTempExpired) {
    headers['x-temp-token'] = tokenStorage.getTempToken().expiresAt;
  }
  if (options.withMfaToken) {
    const mfaToken = tokenStorage.getMfaTokenOptional();
    if (mfaToken) {
      headers['x-mfa-token'] = mfaToken;
    }
  }
  if (options.withLocation) {
    headers['x-location-lat'] = String(tokenStorage.getLocation().lat);
    headers['x-location-lng'] = String(tokenStorage.getLocation().lng);
  }

  return headers;
};
